import { Component } from "@angular/core";
import { LoginService } from "app/services/login/login.service";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
  };

  @Component({
      selector: 'app-desembolso',
      templateUrl: './desembolso.component.html',
      styleUrls: ['./desembolso.component.scss']
  })
  export class DesembolsoComponent {
    
    ID_ROL_PRONTOPAGO = environment.ID_ROL_PP;
    Title: any = 'Desembolsos';
    user: any;
    flagEspecial:boolean=false;
    constructor(private loginService:LoginService){

      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      if(this.user.id_roles == this.ID_ROL_PRONTOPAGO){ 
        this.flagEspecial = true; 
        this.Title = 'Pagos';
      } 
    }

    

    clickGuard(){
      this.loginService.clickGuard = true;
   }
}